import { useOutageBanner } from '@ms/yammer-web-components/dist/outageBanner/hooks';
import { useRebrandingBanner } from '@ms/yammer-web-components/dist/rebrandingBanner';
import Flex, { FlexItem } from '@ms/yammer-web-core-ui/dist/components/Flex';
import React, { useCallback } from 'react';

export const useGetBannersCallback = () => {
  const outageBanner = useOutageBanner();
  const rebrandingBanner = useRebrandingBanner();

  return useCallback(() => {
    const hasAnyBanner = outageBanner || rebrandingBanner;
    const outageBannerContent = outageBanner ? <FlexItem>{outageBanner}</FlexItem> : null;
    const rebrandingBannerContent = rebrandingBanner ? <FlexItem>{rebrandingBanner}</FlexItem> : null;
    const renderContent = hasAnyBanner ? (
      <Flex grow={1} direction="column">
        {outageBannerContent}
        {rebrandingBannerContent}
      </Flex>
    ) : null;

    return renderContent;
  }, [outageBanner, rebrandingBanner]);
};
